<template>
  <span
    class="status-indicator"
    :class="cssUsage"
    v-b-tooltip.hover.bottom="'Status: ' + tooltipText"
  >
  </span>
</template>

<script>
export default {
  name: "FolderStatus",
  props: ["status", "statusResumed"],
  computed: {
    cssUsage() {
      return {
        "badge-success": this.status === "P",
        "badge-primary": this.status === "C",
        "badge-danger": this.status === "R",
      };
    },
    tooltipText() {
      const statusMap = {
        C: "Construindo",
        P: "Pronto",
        R: "Projeto",
      };

      return statusMap[this.status] || "";
    },
  },
};
</script>

<style scoped>
.status-indicator {
  display: inline-block;
  height:12px;
  width: 12px;
  border-radius: 50%;
  transition: transform 0.2s ease;
}

.status-indicator:hover {
  transform: scale(1.2);
}

.badge-success {
  background: #28a745;
}

.badge-primary {
  background: #007bff;
}

.badge-danger {
  background: #dc3545;
}
</style>
